export * from './broadcaster';
export * from './ng2-cable';
export * from './ng2-cable.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
